import axiosIns from '@/plugins/axios'

export default {
  getActiveTableCounts() {
    return axiosIns.get('/v2/monitor/tables/active_table_counts')
  },
}
